export default __webpack_public_path__ + "static/media/rlp_light.065a04a5.png";